//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const next = window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame || function(cb) { window.setTimeout(cb, 1000/60) }

  export default {
    data() {
      return {
        slots:[
          {
            items: [
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            "https://static.soyoung.com/sy-pre/right-1596424200774.png",
            "https://static.soyoung.com/sy-pre/right-1596424200774.png",
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            "https://static.soyoung.com/sy-pre/right-1596424200774.png"
            ] 
          },
          {
            items: [
            "https://static.soyoung.com/sy-pre/right-1596424200774.png",
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            "https://static.soyoung.com/sy-pre/right-1596424200774.png",
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            "https://static.soyoung.com/sy-pre/right-1596424200774.png"
            ] 
          },
          {
            items: [
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            'https://static.soyoung.com/sy-pre/wrong-1596424200774.png',
            ] 
          },
        ],
        opts: null,
        startedAt: null,
      }
    },
    props: {
      no:{
        type:String,
        default(){ return "0" }
      }
    },
    created() {
      this.slotsSelect()
    },
    mounted() {
      this.start()
    },
    methods: {
      start() {
        if (this.opts) {
          return
        }        
        this.opts = this.slots.map( (data, i) => {
          const slot = this.$refs.slots[i];// map(function(){})利用map便利slots的每一个选项组,最终得到return的返回值
          const choice = Math.floor( 3 * data.items.length );// 随机生成一个[0,data.items.length]的整数(floor向下取整)
          console.log("choice", i, data.items[choice])
          const opts = {
            el: slot.querySelector('.slotWrap'),//指向奖项元素的父级;
            finalPos: choice * 55,// 180为每一个奖品滚动标签的高度;
            startOffset:300 + Math.random() * 100 + i * 500,// 影响转的圈数
            height: data.items.length * 55,
            duration: 1000 + i * 700, // milliseconds
            isFinished: false,
          }
          return opts
        })
        next( this.animate );// 开启动画
        },
      animate(timestamp) { // timestamp当前的方法持续的毫秒数
        if (this.startedAt == null) {
            this.startedAt = timestamp// 动画初始时间
        }
        const timeDiff = timestamp - this.startedAt//动画持续的时间
        this.opts.forEach( opt => {
            if(opt.isFinished){
              return
          }
          const timeRemaining = Math.max(opt.duration - timeDiff, 0); // 总的持续时间 - 动画持续时间 = 剩下的时间,0表示结束
          const power = 3
          const offset = ( Math.pow(timeRemaining, power) / Math.pow(opt.duration, power) ) * opt.startOffset
          const pos = -1 * Math.floor((offset + opt.finalPos) % opt.height)
          opt.el.style.transform = "translateY(" + pos + "px)"
          if ( timeDiff > opt.duration ) {
              opt.isFinished = true
          }
        })  
        if (this.opts.every( o => o.isFinished )) {
            this.opts = null
            this.startedAt = null
        } else {
          next( this.animate )
        }
      },
      slotsSelect(){
        switch (this.no) {
            case '0':
              for(let val of this.slots){
                console.log(val)
                val.items.unshift('https://static.soyoung.com/sy-pre/wrong-1596424200774.png')
              }
            break;
            case '1':
              for(let val of this.slots){
                console.log(val)
                val.items.unshift('https://static.soyoung.com/sy-pre/wrong-1596424200774.png')
              }
              this.slots[0].items.unshift('https://static.soyoung.com/sy-pre/right-1596424200774.png')

            break;
            case '2':
            for(let val of this.slots){
                val.items.unshift('https://static.soyoung.com/sy-pre/right-1596424200774.png')
            }
            this.slots[2].items.unshift('https://static.soyoung.com/sy-pre/wrong-1596424200774.png')
            break;
            case '3':
              for(let val of this.slots){
                val.items.unshift('https://static.soyoung.com/sy-pre/right-1596424200774.png')
              }
            break;
        } 
      }
    }
  }
